<template>
  <v-container>
    <component  :is="'script'" type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage":"https://hot-linux.dev/businessinfo",
        "headline":"Hot Linux ／ WEBシステム開発（事業者概要）",
        "description":"Hot Linuxでは小規模WEBシステム開発やPHPプログラミングのアドバイスを中心にお引き受けしております。法人様だけでなく個人事業主様・個人様からの相談も大歓迎です。このページでは事業者情報を掲載しています。",
        "image":[
          "https://hot-linux.dev/img/hot-linux-logos_purple.de39c269.webp"
        ],
        "author":{
          "@type":"Person",
          "name":"山田昌史",
          "url":"https://hot-linux.dev/"
        }
      }
    </component>
    <v-row>
      <v-col cols="12" md="6">
        <left-side>
        </left-side>
      </v-col>
      <v-col cols="12" md="6">
        <v-breadcrumbs
          icon="mdi-map-marker-outline"
          bg-color='grey-lighten-4'
          rounded
        >
          <h3>事業者概要</h3>
        </v-breadcrumbs>

        <v-card class='mx-3 my-3'>
          <v-card-title>
            
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="3">
                代表
              </v-col>
              <v-col>
                山田昌史
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                所在地
              </v-col>
              <v-col>
                愛知県名古屋市<br>
                （ご請求書には正確な住所・電話番号・適格請求書発行事業者登録番号を記載いたします）
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                事業内容
              </v-col>
              <v-col>
                WEBシステムの開発／改修（販売管理・顧客管理等）<br>
                Linuxサーバーの構築（Googleを使った専用サーバー）<br>
                システム・サーバーの保守（Googleを使ったサーバー）<br>
                既存システムのバグ修正<br>
                プログラミングのアドバイス／指導（課題・タスク等）<br>
                等々<br>
                <a href="" @click.stop.prevent='$router.push("/trackrecord")'>過去の実績例</a>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                自己紹介
              </v-col>
              <v-col>
                <span v-html='自己紹介'></span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LeftSide from './LeftSide.vue'
export default {
  components: { LeftSide },

  data(){
    return {
      自己紹介:"",
    }
  },

  mounted(){
    this.サイト情報取得()
  },

  methods:{
    サイト情報取得(){
      this.$emit('overlay');
      let url = './api/api.php';
      let data = {
        func:"サイト情報取得",
        pageSize:10,
      };

      let param = {
          method : "POST",
          headers : { "Content-Type": "application/json" },
          body : JSON.stringify(data),
          }
      fetch(url,param)
      .then(response => {return response.text();})
      .then(result => {
        try {
          const jsonData = JSON.parse(result);
          return jsonData;
        }catch(e){
          return Promise.reject({body:result,type:'unparsable'})
        }
      })
      .then(result => {
        console.log("サイト情報result",result)
        this.自己紹介 = result.サイト情報row.自己紹介;
        this.$emit('overlay');
      })
      .catch(error =>{
        console.log(error)
        alert('取得できませんでした。\n\n'+error.body);
        this.$emit('overlay');
      })
    },
  }

}
</script>